// Terminal output component
import React from 'react';
import ToolTrace from './ToolTrace';
import CaseStudyCard from './CaseStudyCard';
import ProjectList from './ProjectList';

const Prompt = () => (
  <>
    <span className="prompt-user">attuul@portfolio</span>
    <span className="prompt-path">~</span>
    <span className="prompt-caret">❯</span>
  </>
);

// Section headers are ALL-CAPS or a bare Title line; bullets start with •.
// Colouring them here keeps commands.js as plain text.
const lineClass = (line) => {
  const t = line.trim();
  if (!t) return 'output-line output-blank';
  if (/^[A-Z][A-Z0-9 &—-]+$/.test(t)) return 'output-line output-heading';
  if (/^=+$/.test(t)) return 'output-line output-rule';
  if (t.startsWith('•')) return 'output-line output-bullet';
  if (/^[A-Z][A-Za-z &]+$/.test(t) && t.length < 32 && !line.startsWith(' ')) {
    return 'output-line output-subheading';
  }
  return 'output-line';
};

const TerminalOutput = ({ history, github }) => (
  <div className="terminal-output" role="log" aria-live="polite" aria-atomic="false">
    {history.map((entry) => {
      if (entry.type === 'command') {
        return (
          <div key={entry.id} className="output-command">
            <Prompt />
            <span className="command-text">{entry.content}</span>
          </div>
        );
      }

      if (entry.type === 'banner') {
        return (
          <pre key={entry.id} className="output-banner" aria-label="ATTUUL">
            {entry.content.join('\n')}
          </pre>
        );
      }

      if (entry.type === 'trace') {
        return <ToolTrace key={entry.id} steps={entry.steps} onDone={entry.onDone} />;
      }

      if (entry.type === 'case-study') {
        return <CaseStudyCard key={entry.id} study={entry.study} />;
      }

      if (entry.type === 'projects') {
        return <ProjectList key={entry.id} status={github.status} repos={github.repos} />;
      }

      if (entry.type === 'output') {
        return (
          <div key={entry.id} className="output-block">
            {Array.isArray(entry.content)
              ? entry.content.map((line, i) => (
                  <div key={i} className={lineClass(line)}>{line}</div>
                ))
              : <div className={lineClass(entry.content)}>{entry.content}</div>}
          </div>
        );
      }

      if (entry.type === 'typing') {
        return (
          <div key={entry.id} className="output-block">
            <div className="output-line">
              {entry.content}
              <span className="cursor" />
            </div>
          </div>
        );
      }

      return null;
    })}
  </div>
);

export default TerminalOutput;
